module.exports = __webpack_public_path__ + "static/media/english.1a2c0423.png";